/**
 * Calculates the Euclidean distance between two touch points.
 *
 * @param {Touch} touch1 - First touch point with clientX and clientY properties
 * @param {Touch} touch2 - Second touch point with clientX and clientY properties
 * @returns {number} The distance between the two touch points in pixels
 */
export function getDistance(touch1, touch2) {
  const dx = touch2.clientX - touch1.clientX;
  const dy = touch2.clientY - touch1.clientY;
  return Math.sqrt(dx * dx + dy * dy);
}

/**
 * Calculates the center point (midpoint) between two touch points.
 *
 * @param {Touch} touch1 - First touch point with clientX and clientY properties
 * @param {Touch} touch2 - Second touch point with clientX and clientY properties
 * @returns {{x: number, y: number}} The center point with x and y coordinates
 */
export function getCenterPoint(touch1, touch2) {
  return {
    x: (touch1.clientX + touch2.clientX) / 2,
    y: (touch1.clientY + touch2.clientY) / 2
  };
}
